import React from 'react';
import { ContainerComponent, wrap } from 'AppReact';
import { Label, ClickableDiv } from 'atoms';
import { FilterHeaderWrapper, StaticWrapper, FlexCenterWrapper, My1 } from 'wrappers';
import Controller from './controller';
import { BodyWrapper, OptionsWrapper } from './wrappers';
import { Caret, SelectedOption } from './atoms';
import { DownCaretSvg, CloseSvg } from 'components/icons';
import internalState from './internalState';
import { DropdownSearchInput, DropdownRow } from "molecules";
import { testFilter } from 'utils';

export const definition = {
  name: 'Dropdown',
  controller: Controller,
  initialProps: ({ disableLabel, enableFullWidth, options, selectedOptionId, scrollLeft, label, search, nullable, height }) => ({ disableLabel, enableFullWidth, options, selectedOptionId, label, search, scrollLeft, nullable: !!nullable, height }),
  props: internalState,
  elements: [
    {
      wrapper: FilterHeaderWrapper,
      name: 'Selector',
      ref: ({ headerRef }) => headerRef,
      isButton: true,
      displayState: ({ enableFullWidth, height }) => ({ enableFullWidth, height, hasBackground: true }),
      bindings: ({ isOpen, containerRef, headerRef }) => ({ isOpen, containerRef, headerRef }),
      elements: [
        {
          wrapper: FlexCenterWrapper,
          name: 'LeftSide',
          elements: [
            {
              component: Label,
              name: 'Label',
              displayValue: ({ label }) => label || 'Select option: ',
              renderIf: ({ disableLabel }) => !disableLabel,
              bindings: () => ({})
            },
            {
              component: SelectedOption,
              name: 'SelectedValue',
              displayValue: ({ options, selectedOptionId }) => {
                if (selectedOptionId) {
                  const selectedOption = options.find((o) => o.id === selectedOptionId);
                  if (selectedOption) {
                    return selectedOption.display;
                  }
                }
                return '';
              }
            }
          ]
        },
        {
          wrapper: FlexCenterWrapper,
          name: 'Icons',
          elements: [
            {
              component: ClickableDiv,
              renderIf: ({ nullable, selectedOptionId }) => nullable && selectedOptionId,
              name: 'Clear',
              displayValue: () => <CloseSvg />,
              bindings: () => ({})
            },
            {
              component: Caret,
              name: 'DownCaretSvg',
              displayValue: () => <DownCaretSvg />,
              bindings: () => ({})
            }
          ]
        }
      ]
    },
    {
      wrapper: BodyWrapper,
      name: 'Body',
      ref: ({ containerRef }) => containerRef,
      displayState: ({ scrollLeft, headerRef, enableFullWidth }) => ({ left: scrollLeft ? ((headerRef?.current?.offsetLeft ?? 0) - scrollLeft) : 0, enableFullWidth }),
      renderIf: ({ isOpen }) => isOpen,
      elements: [
        {
          component: DropdownSearchInput,
          name: 'Search',
          renderIf: ({ search }) => search,
          bindings: ({ searchTerm }) => ({ value: searchTerm, placeholder: "Search", hideBorder: true })
        },
        {
          wrapper: OptionsWrapper,
          name: 'Options',
          displayState: ({ enableFullWidth }) => ({ enableFullWidth }),
          elements: [
            {
              component: wrap(DropdownRow, My1),
              name: 'Option',
              isListOf: 'options',
              renderIf: ({ searchTerm, option }) => testFilter(option.display, searchTerm),
              bindings: ({ option, selectedOptionId }) => {
                const isSelected = selectedOptionId === option.id;
                return { icon: option.icon, image: option.image, id: option.id, isSelected, selectedOptionIds: [selectedOptionId], singleSelect: true, text: option.display, option, selectedOptionId }
              },
              displayState: ({ option, selectedOptionId }) => ({ isSelected: selectedOptionId === option.id, iconColor: window?.settings?.secondary_color })
            }
          ]
        }
      ]
    }
  ]
};

const Dropdown = ContainerComponent(definition);

export default wrap(Dropdown, StaticWrapper);
